import './Navbar.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";

import {useActions} from '../../../hooks/useActions';
import MusicButton from './MusicButton';
import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";
import {config} from "../../../config";

function NavbarTop() {
    const {user} = useTypedSelector(state => state.auth);

     const {setRoute} = useActions();


    let fontGemsClass = ' menuFontGemSize30'
    if(user.silver.toString().length > 6){
        fontGemsClass = ' menuFontGemSize25';
    }
    if(user.silver.toString().length > 8){
        fontGemsClass = ' menuFontGemSize20';
    }

    return (
        <div className='navbarTop'>
            <div className="main_menu_buttons">
                <div className={'mainMenuGemContainer'}>
                    <div className="main_menu_Gems" title="Gems">
                        <div className={"main_menu_Gems_Amount" + fontGemsClass}>{user.silver}</div>
                        <div className={'mainMenuGemsButtonPlus'}
                             onClick={()=>{
                                 SoundsService.playSound(sounds.menu_open_popup());

                                 if(config.isNutaku) {
                                     setRoute('gem_shop');
                                 }else {
                                     window.open("https://www.patreon.com/c/depravedworld", "_blank");
                                 }
                             }}
                        ></div>
                    </div>

                </div>


                <div className={'mainMenuSoulStoneContainer'}>
                    <div className="main_menu_SoulStone" title="Soul Stones">
                        <div className={"main_menu_Gems_Amount" + fontGemsClass}>{user.soul_stone}</div>
                    </div>
                </div>

                <div className={'mainMenuDivineContainer'}>
                    <div className="main_menu_Divine" title="Divine Essence">
                        <div className={"main_menu_Gems_Amount" + fontGemsClass}>{user.divine_essence}</div>
                    </div>
                </div>

            </div>





            <MusicButton/>

            <div className="map-discord-ico" onClick={() => {
                window.open('https://discord.gg/e5U3UnehP5', "_blank");
            }}></div>

        </div>
    );
}

export default NavbarTop;